import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const CardLoader = () => (
  <Card px={0} py={0} width="100%" maxWidth="1000px" height="100%">
    <Box display="block">
      <Box p={6}>
        <Skeleton isLarge height={50} width="100%" />
      </Box>
      <Box display="block" px={6} pb={6}>
        <Skeleton height={150} width="70%" />
      </Box>
    </Box>
  </Card>
);

export default CardLoader;
